import {inject} from '@angular/core';
import {CanActivateFn, Router, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {catchError, filter, map, take, tap} from 'rxjs/operators';

import {WebStorageService} from '../services/web-storage.service';
import {getCurrentUserLoaded} from '../store/users/selectors/current-user.selectors';
import {loadCurrentUser} from '../store/users/actions/current-user.actions';

function checkStore(): Observable<boolean> {
  const store: Store = inject<Store>(Store);

  return store.pipe(
    select(getCurrentUserLoaded),
    tap((loaded: boolean): void => {
      if (!loaded) {
        store.dispatch(loadCurrentUser());
      }
    }),
    filter((loaded: boolean): boolean => loaded === true),
    take(1)
  );
}


export const requiredAuthorizationGuard: CanActivateFn = (): Observable<boolean | UrlTree> => {
  const storageService: WebStorageService = inject(WebStorageService);
  const router: Router = inject(Router);

  const loginPage: UrlTree = router.parseUrl('/login');
  const chooseOrganizationPage: UrlTree = router.parseUrl('/choose-organization');

  const token = storageService.getItem('token');
  const organizationId: number = storageService.getNumber('organizationId');
  if (!token) {
    return of(loginPage);
  }

  if (!organizationId) {
    return of(chooseOrganizationPage);
  }

  return checkStore().pipe(
    map((): boolean => true),
    catchError((error: unknown): Observable<UrlTree> => {
      console.error('Failed to load current user in auth guard', error);
      return of(loginPage);
    })
  );
};
